interface TimeSlot {
	timeRange: string;
	statusText?: string;
}

export function formatTimeRange(selected_date: string): TimeSlot {
	const now = new Date();
	const startTime = new Date(selected_date);
	const endTime = new Date(startTime.getTime() + 50 * 60 * 1000);

	// Format time as HH:MM
	const formatTime = (date: Date) => {
		return date.toLocaleTimeString('pt-BR', {
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
		});
	};

	const timeRange = `${formatTime(startTime)} - ${formatTime(endTime)}`;

	// Only calculate difference if it's the same day
	if (now.toDateString() !== startTime.toDateString()) {
		return { timeRange };
	}

	const diffMinutes = Math.round(
		(startTime.getTime() - now.getTime()) / (1000 * 60),
	);
	const absoluteDiff = Math.abs(diffMinutes);

	let statusText: string | undefined;

	if (diffMinutes <= 0 && now < endTime) {
		statusText = '⊙ Agora';
	} else if (diffMinutes < 0) {
		statusText = formatTimeDifference(absoluteDiff, true);
	} else {
		statusText = formatTimeDifference(absoluteDiff, false);
	}

	return { timeRange, statusText };
}

export function formatTimeDifference(minutes: number, isPast: boolean): string {
	if (minutes < 60) {
		return `• ${isPast ? 'Há' : 'Daqui a'} ${minutes} min`;
	}

	const hours = Math.floor(minutes / 60);
	const remainingMinutes = minutes % 60;

	let timeString = `• ${isPast ? 'Há' : 'Daqui a'} ${hours} ${
		hours === 1 ? 'hr' : 'hrs'
	}`;
	if (remainingMinutes > 0) {
		timeString += ` e ${remainingMinutes} min`;
	}

	return timeString;
}
